import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  EReconciliationStatus,
  IReconciliationGetParticipantsResponse,
  IReconciliationGetReconciliationsResponse,
  TReconciliationCounterpartyListReqParams,
  TReconciliationCounterpartyParticipantsListReqParams,
  TReconciliationParticipantsListReqParams,
} from '../types/reconciliation.types';

export const reconciliationGetParticipantsService = async (
  params: TReconciliationParticipantsListReqParams,
): Promise<IReconciliationGetParticipantsResponse> => {
  const url = API_ENDPOINTS.RECONCILIATION.RECONS_PARTICIPANTS;
  const config = {
    params,
  };
  const res = await apiClient.get<IReconciliationGetParticipantsResponse>(url, config);

  return res.data;
};

export const reconciliationGetCounterpartyParticipantsService = async (
  counterpartyGUID: string,
  params: TReconciliationCounterpartyParticipantsListReqParams,
): Promise<IReconciliationGetParticipantsResponse> => {
  const config = {
    params,
  };
  const url = API_ENDPOINTS.RECONCILIATION.COUNTERPARTY_RECONS_PARTICIPANTS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.get<IReconciliationGetParticipantsResponse>(url, config);

  return res.data;
};

export const reconciliationGetCounterpartyListService = async (
  debtorGUID: string,
  creditorGUID: string,
  reqParams: TReconciliationCounterpartyListReqParams,
): Promise<IReconciliationGetReconciliationsResponse> => {
  const params = reqParams;
  if (creditorGUID) params.participant_counterparty_guid = creditorGUID;
  const url = API_ENDPOINTS.RECONCILIATION.COUNTERPARTY_RECONS.replace(EApiPathParams.CounterpartyGuid, debtorGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<IReconciliationGetReconciliationsResponse>(url, config);

  return res.data;
};

export const reconciliationSetStatusService = async (
  counterpartyGUID: string,
  reconGUID: string,
  status: EReconciliationStatus,
): Promise<boolean> => {
  const url = API_ENDPOINTS.RECONCILIATION.COUNTERPARTY_RECON
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.ReconGuid, reconGUID);
  const res = await apiClient.put(url, { status });

  return res.status === 200;
};
